import { ref } from 'vue'
import { DatasourceMailerApi } from '@/services'

export function useDatasourceMailerCrud () {
  const datasourceMailer = ref({})
  const datasourceMailers = ref([])
  const datasourceMailerAttachment = ref({})

  async function save (datasourceMailer) {
    datasourceMailer.value = await DatasourceMailerApi.saveDatasourceMailer(datasourceMailer)
    return datasourceMailer
  }

  async function fetch (datasourceMailerId) {
    datasourceMailer.value = await DatasourceMailerApi.fetchDatasourceMailer(datasourceMailerId)
    return datasourceMailer
  }

  async function fetchAttachment (datasourceMailerId, attachmentId) {
    datasourceMailerAttachment.value = await DatasourceMailerApi.fetchDatasourceMailerAttachment(datasourceMailerId, attachmentId)
    return datasourceMailerAttachment
  }

  async function downloadAttachment (datasourceMailerId, attachmentId) {
    try {
      const attachmentData = await DatasourceMailerApi.fetchDatasourceMailerAttachmentDownloadUrl(datasourceMailerId, attachmentId)
      const downloadLink = document.createElement('a')
      downloadLink.setAttribute('href', attachmentData.url)
      downloadLink.setAttribute('style', 'display:none')
      downloadLink.setAttribute('target', '_blank')
      document.body.append(downloadLink)

      setTimeout(function () {
        downloadLink.click()
        downloadLink.remove()
      }, null)
    } catch (error) {
      this.$flash({
        showClose: true,
        message: 'Error downloading Attachment! ' + error.message,
        type: 'error'
      })
    }
  }

  async function fetchAll () {
    datasourceMailers.value = await DatasourceMailerApi.fetchDatasourceMailers()
    return datasourceMailers
  }

  async function destroy (datasourceMailerId) {
    return DatasourceMailerApi.deleteDatasourceMailer(datasourceMailerId)
  }

  return {
    datasourceMailer,
    datasourceMailers,
    datasourceMailerAttachment,
    fetch,
    fetchAll,
    save,
    destroy,
    fetchAttachment,
    downloadAttachment
  }
}
